import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { handleLoader, handleNotFound } from 'redux/counterSlice';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { genrate_vectorDB, getFilesByWebsiteId, get_scrape, get_url_by_clientname, get_zip } from 'services/webScrapperService';
import DataShowModal from 'components/DataShowModal';
import { classNames } from 'primereact/utils';
import { InputIcon } from 'primereact/inputicon';
import { IconField } from 'primereact/iconfield';
import { InputText } from 'primereact/inputtext';
const moment = require('moment');

const WebScrapper = () => {
  const {
    handleSubmit,
    formState: { errors },
    control,
    watch
  } = useForm<any>({ defaultValues: { siteURL: '' } })

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams()
  const [urlList, setUrlList] = useState<any>([])
  const [urlList2, setUrlList2] = useState<any>([]);
  const [extractList, setExtractList] = useState<any>([]);
  const [dynamicId, setDynamicId] = useState<any>("");
  const [dynamicData, setDynamicData] = useState<any>("");
  const [visible, setVisible] = useState(false);

  // const getSeverity = (status: string) => {
  //   switch (status) {

  //     case 'Success':
  //       return 'success';

  //     case 'Failed':
  //       return 'danger';
  //   }
  // };

  const siteURL = watch("siteURL");

  const getDataByID = async (id: string) => {
    dispatch(handleLoader(true));
    try {
      // const res = await axios.get(`http://172.17.1.53:4009/get_url_by_client_name?website_id=${id}&client_env=RON`)
      const { result1, error1 } = await get_url_by_clientname(id)
      if (error1) {
        throw error1
      }
      if (result1?.error) {
        throw result1.error
      }
      let resultRes = result1.message;
      const { result, error } = await getFilesByWebsiteId(id);
      if (error) {
        throw error
      }
      if (result?.error) {
        throw result.error
      }
      setExtractList(result);
      dispatch(handleLoader(false));
      const mergedArray = resultRes.map((obj1: any) => {
        const matchedObj2 = result.find((obj2: any) => obj2.file_name.replace(/\.[^.]+$/, '') === obj1.file_name);
        return { ...obj1, ...matchedObj2 };
      });
      setUrlList2(result?.length > 0 ? mergedArray : resultRes);
    } catch (error: any) {
      dispatch(handleLoader(false));
      toast.error(error.message, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      });
    }
  }

  const genrateVector = async (data: any) => {
    try {
      const { result, error } = await genrate_vectorDB(data);
      if (error) {
        throw error
      }
      if (result?.error) {
        throw result.error
      }
    } catch (error: any) {
      dispatch(handleLoader(false));
      toast.error(error.message, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      });
    }
  }

  const getZip = async () => {
    dispatch(handleLoader(true));
    let clientName = params.id === "new" ? urlList.website_name : urlList2[0]?.website_name;
    let clientId = params.id === "new" ? urlList.website_id : urlList2[0]?.website_id;
    try {
      const { result, error } = await get_zip(clientName);
      if (error) {
        throw error
      }
      if (result?.error) {
        throw result.error
      }
      dispatch(handleLoader(false));
      toast.success("Your request is being processed", {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
      let body: any = {}
      body.user_name = localStorage.getItem("username");
      body.client_name = clientName;
      body.base64_zip_content = result;
      body.website_id = clientId;
      await genrateVector(body)

    } catch (error: any) {
      dispatch(handleLoader(false));
      toast.error(error.message, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      });
    }
  }



  const onSubmit = async (data: any) => {
    dispatch(handleLoader(true));
    try {
      const { result, error } = await get_scrape(data.siteURL);
      if (error) {
        throw error;
      }

      if (typeof result === 'string') {
        // Handle the case where result is a single line string
        const extractedText = result.match(/'([^']+)'/)?.[1];
        if (extractedText) {
          toast.error(`Unfortunately, it is not possible to scrape the website ${extractedText}`, {
            style: {
              backgroundColor: '#F1F1F1', // Grey background
            }
          });
        } else {
          // Handle other actions as needed
        }
      } else {
        if (result?.error) {
          throw result.error;
        }

        let temp: any = result[0];
        temp["urls"] = [...result[0]?.Scraped_urls, ...result[0]?.Not_Scraped_urls];
        setUrlList(temp);
      }

      dispatch(handleLoader(false));
    } catch (error: any) {
      dispatch(handleLoader(false));
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      });
    }
  };

  const temp = (e: any) => {
    if (params.id === "new") {
      return e === "success" ? 'Success' : 'Failed'
    } else {
      return e === true ? 'Success' : 'Failed'
    }
  };
  useEffect(() => {
    dispatch(handleNotFound(false))
    if (params.id !== "new") {
      getDataByID(params.id as string);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleData = (id: string, data: string) => {
    setDynamicId(id);
    setDynamicData(data);
    data && setVisible(true)
  }

  const onClose = () => setVisible(false)

  const downloadFile = (base64String: string, is_processed: boolean) => {
    if (is_processed) {

      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters?.length);

      for (let i = 0; i < byteCharacters?.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'text/plain' });

      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = 'downloadedFile.txt';
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      toast.success("File is downloaded", {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      })
    }
  };

  useEffect(() => {
    if (visible) {
      document.body?.classList.add("modal-open-vocie");
    } else if (!visible && document.body?.classList?.contains("modal-open-vocie")) {
      document.body?.classList.remove("modal-open-vocie");
    }
  }, [visible])

  return (
    <div className='p-4 content-wrapper'>
      <section
        className="web-scrapper-chat-component-main-section user-management-section"
      >
        <div className='d-flex align-items-center flex-wrap justify-content-between mb-2'>
          <h4 className='mb-0'><span onClick={async () => {
            navigate('/admin/web-scrapper')
          }} className='pi pi-chevron-left mr-2 cursor-pointer'></span>{params.id === "new" ? <span>New Website Scrapping</span> : <span>View Scrapping</span>}</h4>
          {params.id === "new" &&
            <div className='d-flex flex-wrap align-items-center site-url'>
              {/* search-box */}
              <div className='search-box-container row gx-2'>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className='web-search-box'>
                    <Controller
                      name="siteURL"
                      control={control}
                      defaultValue=""
                      // rules={{ required: 'This field is required', maxLength: 30 }}
                      render={({ field }) => (
                        <IconField iconPosition="right" className=''>
                          {/* <InputIcon className="pi pi-search"></InputIcon> */}
                          <InputText
                            {...field}
                            className={`input-box`}
                            placeholder="Enter Site URL"
                            type="text"
                            autoComplete="off"
                          />
                        </IconField>

                      )}
                    />
                    <Button
                      className="btn btn-primary mt-2 mt-md-0 mr-0 btn-submit"
                      style={siteURL === "" ? { backgroundColor: "grey !important", borderColor: "grey" } : {}}
                      onClick={handleSubmit(onSubmit)}
                      disabled={siteURL === ""}
                    >
                      Scrape URL
                    </Button>
                  </div>
                  {errors.siteURL && (<p className="text-danger">{errors.siteURL.message as any}</p>)}
                </form>
              </div>
            </div>
          }
        </div>

        <div className="d-flex justify-content-between align-items-center flex-wrap dash-box-wrap">
          <div className="col-4">
            <div className="inner-dash-box">
              <svg width="62" height="62" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_38_6)">
                  <circle cx="30" cy="30" r="30" fill="#9882d4" />
                </g>
                <path d="M23.2666 34.4869L34.4843 23.2692L36.6619 25.4468L25.4442 36.6645L23.2666 34.4869Z" fill="#FEFEFE" />
                <path d="M41.6665 18.3333C40.1731 16.84 38.1198 16 36.0665 16C34.0131 16 31.9598 16.84 30.4665 18.3333L25.7998 23L28.0398 25.24L32.7065 20.5733C33.6398 19.64 34.8531 19.1733 36.1598 19.1733C37.4665 19.1733 38.6798 19.64 39.6131 20.5733C40.5465 21.5067 41.0131 22.72 41.0131 24.0267C41.0131 25.3333 40.5465 26.5467 39.6131 27.48L34.9465 32.1467L37.1865 34.3867L41.8531 29.72C43.3465 28.2267 44.1865 26.1733 44.1865 24.12C43.9998 21.88 43.1598 19.8267 41.6665 18.3333Z" fill="#FEFEFE" />
                <path d="M27.3867 39.4265C26.4533 40.3599 25.24 40.8265 23.9333 40.8265C22.6267 40.8265 21.4133 40.3599 20.48 39.4265C19.5467 38.4932 19.08 37.2799 19.08 35.9732C19.08 34.6665 19.5467 33.4532 20.48 32.5199L25.1467 27.8532L22.9067 25.6132L18.24 30.2799C16.84 31.8665 16 33.9199 16 36.0665C16 38.2132 16.84 40.1732 18.3333 41.6665C19.8267 43.1599 21.88 43.9999 23.9333 43.9999C25.9867 43.9999 28.04 43.1599 29.5333 41.6665L34.2 36.9999L31.96 34.7599L27.3867 39.4265Z" fill="#FEFEFE" />
              </svg>
              <div className='right-info'>
                <p className="m-0">Total URLs</p>
                {params.id === "new" ?
                  <strong>{urlList?.Website_count > 0 ? urlList.Website_count : 0}</strong>
                  :
                  <strong>{urlList2?.length > 0 ? urlList2.length : 0}</strong>
                }
              </div>
            </div>
          </div>
          <div className="col-4">
            <div className="inner-dash-box" >
              <svg width="62" height="62" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_38_18)">
                  <circle cx="30" cy="30" r="30" fill="#6FBE46" />
                </g>
                <path d="M24.3639 17.2727V22.3636H19.2729L24.3639 17.2727Z" fill="#FEFEFE" />
                <path d="M40.9091 18.5455V27.1618C39.1104 25.7009 36.8627 24.9052 34.5455 24.9091C32.2896 24.9127 30.0988 25.6655 28.3171 27.049C26.5354 28.4326 25.2636 30.3688 24.7014 32.5534C24.1392 34.7381 24.3184 37.0476 25.211 39.1194C26.1035 41.1912 27.6589 42.9079 29.6327 44H20.5455C19.8704 44 19.2229 43.7318 18.7455 43.2545C18.2682 42.7771 18 42.1296 18 41.4545V24.9091H25.6364C25.9739 24.9091 26.2976 24.775 26.5363 24.5363C26.775 24.2976 26.9091 23.9739 26.9091 23.6364V16H38.3636C39.0387 16 39.6862 16.2682 40.1635 16.7455C40.6409 17.2229 40.9091 17.8704 40.9091 18.5455Z" fill="#FEFEFE" />
                <path d="M35 27C30.576 27 27 30.576 27 35C27 39.424 30.576 43 35 43C39.424 43 43 39.424 43 35C43 30.576 39.424 27 35 27ZM33.8756 38.6129C33.7281 38.7604 33.5438 38.8341 33.3594 38.8341C33.1751 38.8341 32.9908 38.7604 32.8433 38.6129L29.9677 35.7373L31.0184 34.6866L33.341 37.0461L38.6129 31.7742L39.6636 32.8249L33.8756 38.6129Z" fill="#FEFEFE" />
              </svg>
              <div className='right-info'>
                <p className="m-0">Successfully Scrapped Pages</p>
                {params.id === "new" ?
                  <strong>{urlList?.count_scraped_url > 0 ? urlList.count_scraped_url : 0}</strong>
                  :
                  <strong>{urlList2?.filter((e: any) => e.status === true).length > 0 ? urlList2?.filter((e: any) => e.status === true).length : 0}</strong>
                }
              </div>
            </div>
          </div>
          <div className="col-4">
            <div className="inner-dash-box">
              <svg width="62" height="62" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_38_29)">
                  <path d="M60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30Z" fill="#808285" />
                </g>
                <path d="M24.3639 17.2727V22.3636H19.2729L24.3639 17.2727Z" fill="#FEFEFE" />
                <path d="M40.9091 18.5455V27.1618C39.1104 25.7009 36.8627 24.9052 34.5455 24.9091C32.2896 24.9127 30.0988 25.6655 28.3171 27.049C26.5354 28.4326 25.2636 30.3688 24.7014 32.5534C24.1392 34.7381 24.3184 37.0476 25.211 39.1194C26.1035 41.1912 27.6589 42.9079 29.6327 44H20.5455C19.8704 44 19.2229 43.7318 18.7455 43.2545C18.2682 42.7771 18 42.1296 18 41.4545V24.9091H25.6364C25.9739 24.9091 26.2976 24.775 26.5363 24.5363C26.775 24.2976 26.9091 23.9739 26.9091 23.6364V16H38.3636C39.0387 16 39.6862 16.2682 40.1635 16.7455C40.6409 17.2229 40.9091 17.8704 40.9091 18.5455Z" fill="#FEFEFE" />
                <path d="M34.5455 27.4545C33.0352 27.4545 31.5588 27.9024 30.303 28.7415C29.0472 29.5806 28.0684 30.7732 27.4905 32.1686C26.9125 33.564 26.7613 35.0994 27.0559 36.5807C27.3506 38.062 28.0779 39.4227 29.1458 40.4906C30.2138 41.5586 31.5745 42.2859 33.0558 42.5805C34.5371 42.8752 36.0725 42.724 37.4679 42.146C38.8632 41.568 40.0559 40.5892 40.8949 39.3334C41.734 38.0777 42.1819 36.6012 42.1819 35.0909C42.1819 33.0656 41.3774 31.1233 39.9453 29.6912C38.5132 28.2591 36.5708 27.4545 34.5455 27.4545ZM35.8183 39.1818C35.8183 39.5194 35.6842 39.8431 35.4455 40.0818C35.2068 40.3205 34.8831 40.4545 34.5455 40.4545C34.208 40.4545 33.8843 40.3205 33.6456 40.0818C33.4069 39.8431 33.2728 39.5194 33.2728 39.1818V38.9091C33.2728 38.5715 33.4069 38.2478 33.6456 38.0091C33.8843 37.7705 34.208 37.6364 34.5455 37.6364C34.8831 37.6364 35.2068 37.7705 35.4455 38.0091C35.6842 38.2478 35.8183 38.5715 35.8183 38.9091V39.1818ZM35.8183 35.0909C35.8183 35.4285 35.6842 35.7522 35.4455 35.9909C35.2068 36.2295 34.8831 36.3636 34.5455 36.3636C34.208 36.3636 33.8843 36.2295 33.6456 35.9909C33.4069 35.7522 33.2728 35.4285 33.2728 35.0909V31C33.2728 30.6625 33.4069 30.3387 33.6456 30.1C33.8843 29.8614 34.208 29.7273 34.5455 29.7273C34.8831 29.7273 35.2068 29.8614 35.4455 30.1C35.6842 30.3387 35.8183 30.6625 35.8183 31V35.0909Z" fill="#FEFEFE" />
              </svg>
              <div className='right-info'>
                <p className="m-0">Unsuccessfully Scrapped Pages</p>
                {params.id === "new" ?
                  <strong>{urlList?.count_not_scraped_url > 0 ? urlList.count_not_scraped_url : 0}</strong>
                  :
                  <strong>{urlList2?.filter((e: any) => e.status !== true).length > 0 ? urlList2?.filter((e: any) => e.status !== true).length : 0}</strong>
                }
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
        <div className='web-scrapper-conversation-container'>
          {/* <div className='p-4 content-wrapper'> */}
          {/* <section className="switch-section user-management-section"> */}
          <div className="d-flex justify-content-between align-items-center scraper-header">
            <h4 className='mb-0'>Website Scraper</h4>
            {(urlList?.urls?.length > 0 || urlList2?.length > 0) &&
              <Button className='outline-icon-btn' onClick={async () => { getZip() }}>Generate Vector</Button>
            }
          </div>
          <div className="datatable-wrapper">
            <DataTable paginator rows={10} rowsPerPageOptions={[10, 25]} stripedRows value={params.id === "new" ? urlList?.urls : urlList2} tableStyle={{}} emptyMessage="No website records found">

              <Column field={params.id !== "new" ? "url" : "urls"} header="URL" body={(rowData: any) => (<a href={params.id === "new" ? rowData.url : rowData.urls} target="_blank" rel="noopener noreferrer">{params.id === "new" ? rowData.url : rowData.urls}</a>)} style={{ width: "45%" }} ></Column>
              <Column
                header="Date & Time"
                body={(rowData: any) => (moment(rowData.created_time).format('MMM DD, YYYY HH:mm:ss'))}
                sortable
                sortField='created_time'
              >
              </Column>
              {/* <Column field="status" header="Status" sortField='status' showFilterMenu={false} filterMenuStyle={{ width: '18rem' }} body={(rowData) => (<i className={classNames('pi', { 'fa-solid fa-circle-check': rowData.status, 'fa-solid fa-circle-xmark': !rowData.status, })} style={{ color: rowData.status ? "#01C324" : "#F84F4F", fontSize: "20px" }}></i>)} /> */}
              <Column field="status" header="Status" sortField='status' showFilterMenu={false} filterMenuStyle={{ width: '18rem' }} body={(rowData) => (<Tag className={rowData.status ? "status-tag active" : "status-tag reject"} value={rowData.status ? 'Success' : 'Failed'} />)} />
              {extractList?.length > 0 &&
                <Column field="is_processed" style={{ cursor: "pointer" }} header="Processed" sortField='is_processed' showFilterMenu={false} filterMenuStyle={{ width: '18rem' }} body={(rowData) => (<Tag className={rowData.is_processed ? "status-tag active" : "status-tag reject"} onClick={() => { downloadFile(rowData.file_data, rowData.is_processed) }} value={temp(rowData.is_processed)} />)} />
              }
              {extractList?.length > 0 &&
                <Column field="is_NER" style={{ cursor: "pointer" }} header="Entities" sortField='is_NER' showFilterMenu={false} filterMenuStyle={{ width: '18rem' }} body={(rowData) => (<Tag className={rowData.is_NER ? "status-tag active_with_border" : "status-tag reject"} onClick={() => { handleData("Entities", rowData.is_ner_content) }} value={temp(rowData.is_NER)} />)} />
              }
              {/* {extractList.length > 0 &&
              <Column field="is_summarization" style={{ cursor: "pointer" }} header="Summary" sortField='is_summarization' showFilterMenu={false} filterMenuStyle={{ width: '18rem' }} body={(rowData) => (<Tag onClick={() => { handleData("Summarization", rowData.is_summarization_content) }} value={temp(rowData.is_summarization)} severity={getSeverity(temp(rowData.is_summarization))} />)} />
            } */}
              {extractList?.length > 0 &&
                <Column field="is_classification" style={{ cursor: "pointer" }} header="Classification" sortField='is_classification' showFilterMenu={false} filterMenuStyle={{ width: '18rem' }} body={(rowData) => (<Tag className={rowData.is_classification ? "status-tag active_with_border" : "status-tag reject"} onClick={() => { handleData('Classification', rowData.is_classification_content) }} value={temp(rowData.is_classification)} />)} />
              }
            </DataTable>
          </div>
          {/* </section> */}
          {/* </div > */}
        </div>
        <DataShowModal visible={visible} close={onClose} d_data={dynamicData} d_id={dynamicId} />
      </section>
    </div>
  )
}

export default WebScrapper